import HttpFactory from '../factory'
import type { CareTeam } from '../types/care-team'
import type { Practitioner } from '../types/practitioner/practitioner'

class CareTeamsModule extends HttpFactory<any[]> {
  private RESOURCE = '/care-teams'

  async get(id?: string): Promise<CareTeam | CareTeam[]> {
    if (id) {
      return await this.call<any>('GET', `${this.RESOURCE}/${id}`)
    } else return await this.call<any>('GET', `${this.RESOURCE}`).then((response) => response.items)
  }

  async addPractitioner(ct: string, practitionerId: string): Promise<void> {
    return this.call<any>('POST', `${this.RESOURCE}/${ct}/practitioners`, {
      practitionerId,
    })
  }

  async removePractitioner(ct: string, practitionerId: string): Promise<void> {
    return this.call<any>('DELETE', `${this.RESOURCE}/${ct}/practitioners/${practitionerId}`)
  }

  async save(obj: any): Promise<CareTeam> {
    const data = {
      name: obj.name,
      role: obj.role,
      careTypes: obj.careTypes,
      organizationId: obj.organizationId,
      description: obj.description,
      telecom: obj.telecom,
    }

    if (obj.id) {
      return this.call<any>('PATCH', `${this.RESOURCE}/${obj.id}?revision=${obj.revision}`, data)
    } else {
      return this.call<any>('POST', `${this.RESOURCE}`, data)
    }
  }

  async getPractitioners(ct: string): Promise<Practitioner> {
    const data = await this.call<any>('GET', `${this.RESOURCE}/${ct}/practitioners`)
    return data?.items?.map((e: any) => e.id) || []
  }

  async activeDeactiveCareTeam(ct: Partial<CareTeam>): Promise<CareTeam> {
    return this.call<any>('PATCH', `${this.RESOURCE}/${ct.id}?revision=${ct.revision}`, {
      active: ct.active,
    })
  }
}

export default CareTeamsModule
